/* eslint-disable no-param-reassign */
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import { CustomColumn, FlagNew, SDeleteIcon, Text } from './styled';

const addDeleteIcon = ({
  title,
  id,
  showDeleteIcon,
  onCloseHeaderColumn,
}: {
  title: string;
  id: number;
  showDeleteIcon: boolean;
  onCloseHeaderColumn: (id: number) => void;
}) => (
  <CustomColumn>
    {showDeleteIcon && (
      <SDeleteIcon
        className="delete-column-icon"
        title="Delete this column"
        onClick={(e) => {
          e.stopPropagation();
          onCloseHeaderColumn(id);
        }}
      >
        X
      </SDeleteIcon>
    )}
    <Text>{title}</Text>
  </CustomColumn>
);

const setColumnOrder = (
  orderAtIndex: number,
  index: number,
  sortType: string,
) => {
  const targetColumnOrder = orderAtIndex - 1;
  const targetColumnSort =
    sortType.toLowerCase() === 'asc' ? 'ascend' : 'descend';

  if (targetColumnOrder === index) return targetColumnSort;
  return false;
};

const directionsOption = (sortType: string) => {
  if (sortType.toLowerCase() === 'asc') return ['ascend', 'descend'];
  return ['descend', 'ascend'];
};

const addSymbolColumnAndEmptySpace = (rawColumn = []) => {
  const compiledColumns = [
    {
      title: 'Symbol',
      className: 'custom-column not-dragable',
      dataIndex: ['company', 'symbol'],
      isRemovable: 0,
      sorter: true,
      coloring: 0,
      width: 120,
      // textWrap: 'word-break',
      key: 9999,
      fixed: 'left',
      render: (symbol, row) => (
        <Flex width="120px" className="cell-symbol-title">
          <Link href={`/symbol/${symbol}`} passHref>
            <Text
              width="55%"
              family="bold"
              as="a"
              color={color.dark}
              target="_blank"
            >
              {symbol}
            </Text>
          </Link>
          {row.company.badges?.is_new && (
            <FlagNew>
              <Text size="11px" family="bold" color={color.primary} as="span">
                New
              </Text>
            </FlagNew>
          )}
        </Flex>
      ),
    },
    ...rawColumn,
    // add empty column to make column respect width (130px)
    {
      title: '',
      className: 'custom-column not-dragable',
      dataIndex: [''],
      isRemovable: 0,
      sorter: false,
      id: 0,
      coloring: 0,
      width: undefined,
      textWrap: 'word-break',
    },
  ];

  return compiledColumns;
};

// eslint-disable-next-line comma-spacing
const moveArrayElements = <T,>(arr: T[], indexA: number, indexB: number) => {
  const clonedArr = [...arr];
  const element = clonedArr[indexA];
  if (element) {
    clonedArr.splice(indexA, 1);
    clonedArr.splice(indexB, 0, element);
  }
  return clonedArr;
};

export {
  moveArrayElements,
  addSymbolColumnAndEmptySpace,
  directionsOption,
  setColumnOrder,
  addDeleteIcon,
};
